{
  "#SALES": {
    "TITLE": "Verkauf",
    "OVERVIEW": "Verkauf",
    "OVERVIEW_PAGE_TITLE": "Verkaufsübersicht",
    "DOCUMENT": "Belegerfassung",
    "CREATE_DOCUMENT": "Beleg erstellen",
    "POSITIONS": {
      "EDIT_PRODUCT_TEXT": "Textposition bearbeiten",
      "EDIT_MANUAL_ARTICLE": "Manuellen Artikel bearbeiten",
      "EDIT_SECTION": "Abschnittstext bearbeiten",
      "EDIT_FLATRATE": "Pauschalentext bearbeiten",
      "EDIT_LINE_TEXT": "Zeilentext bearbeiten",
      "ADD_LINE_TEXT": "Zeilentext hinzufügen",
      "INSERT_ROW_ABOVE": "Zeile darüber einfügen",
      "INSERT_ROW_BELOW": "Zeile darunter einfügen",
      "MOVE_UP": "Zeile nach oben verschieben",
      "MOVE_DOWN": "Zeile nach unten verschieben",
      "DUPLICATE": "Duplizieren",
      "COPY": "Kopieren",
      "PASTE": "Einfügen",
      "COPY_TO_NEW_DOCUMENT": "In neuen Beleg kopieren",
      "FULFILL_TO_NEW_DOCUMENT": "In neuen Beleg abbuchen",
      "TYPE": {
        "SECTION": "Abschnitt – gliedert die Positionen darunter",
        "TEXT": "Textartikel – reiner Text, ohne Menge und Preis",
        "FLAT_RATE": "Pauschale – rechnet die Positionen darunter zu einem Preis ab",
        "RETURNABLE": "Emballage – vom System zur Hauptposition erzeugt",
        "CUSTOMIZABLE": "Manueller Artikel (Divers) – Bezeichnung frei erfassbar",
        "UNIT": "Einheit"
      },
      "MANUAL_DESCRIPTION": "Bezeichnung manuell geändert",
      "MANUAL_CHANGE": "Manuell geändert - Wert wird von der Preisfindung nicht überschrieben",
      "ATTRIBUTES": {
        "COLUMN": "Attribute",
        "MORE": "+{{count}} weitere",
        "ADD_EMPTY": "Attribut",
        "MANAGE": "Attribute verwalten",
        "TITLE": "Position {{position}}",
        "CLOSE": "Schließen",
        "ORIGIN": "Herkunft",
        "ORIGIN_TITLE": "Abgebucht aus {{document}}",
        "ORIGIN_POSITION": "Position {{position}}",
        "OPEN": "Öffnen",
        "REMOVE": "{{name}} entfernen",
        "READONLY": "Nicht änderbar",
        "EMPTY": "Keine Attribute gesetzt.",
        "ADD": "Attribut hinzufügen",
        "ADD_NONE": "Keine weiteren Attribute möglich.",
        "REMOVE_ALL": "Alle entfernen",
        "DESCRIPTION": {
          "total": "Bildet die Endsumme über die vorangehenden Positionen und weist sie im Druck aus.",
          "subtotal": "Bildet eine Zwischensumme über die vorangehenden Positionen und weist sie im Druck aus.",
          "alternative": "Alternativposition – zählt nicht zur Belegsumme.",
          "pageBreak": "Erzwingt im Druck einen Seitenumbruch nach dieser Position.",
          "pickUp": "Position wird auf den Abholschein übernommen.",
          "pickUpDigitalStorage": "Position wird auf den Abholschein des digitalen Lagers übernommen.",
          "promotion": "Aktionspreis aus einer laufenden Aktion.",
          "calculationSheet": "Preis stammt aus einem Kalkulationsblatt."
        }
      }
    },
    "ACTIONS": {
      "MENU": "Aktionen",
      "GROUP_EDIT": "Bearbeiten",
      "GROUP_STRUCTURE": "Struktur",
      "GROUP_CONVERT": "Summe & Umwandeln",
      "GROUP_INSERT": "Zeilen einfügen",
      "GROUP_ORDER": "Reihenfolge",
      "makeTotal": "Als Endsumme",
      "makeSubtotal": "Als Zwischensumme",
      "makeAlternative": "Als Alternative",
      "makePageBreak": "Seitenumbruch",
      "removePageBreak": "Seitenumbruch entfernen",
      "editDescription": "Beschreibung bearbeiten",
      "editDocumentNotes": "Belegvermerk",
      "addToNewFlatrate": "Zu neuer Pauschale hinzufügen",
      "addToNewSection": "Zu neuem Abschnitt hinzufügen",
      "mergeDuplicates": "Positionen zusammenführen",
      "undoSection": "Abschnitt auflösen",
      "undoFlatrate": "Pauschale auflösen",
      "pickUp": "Abholschein",
      "undoPickUp": "Abholschein entfernen",
      "pickUpDigitalStorage": "Abholschein Digitales Lager",
      "undoPickUpDigitalStorage": "Abholschein Digitales Lager entfernen",
      "deletable": "Löschen",
      "recalculatePrice": "Preis neu berechnen",
      "recalculateCashPrice": "Barpreis neu berechnen"
    },
    "DOCUMENT_NOTES": {
      "TITLE": "Belegvermerke"
    },
    "DOCUMENT_SYMBOLS": {
      "TITLE": "Symbole",
      "MORE": "+{{count}} weitere",
      "SHOW_ALL": "Alle Symbole anzeigen",
      "CLOSE": "Schließen",
      "LABEL": {
        "DOCUMENT_NOTE": "Belegvermerk",
        "SIGNATURE": "Signatur",
        "DOWN_PAYMENT": "Anzahlung",
        "MAINTENANCE_DOCUMENT": "Wartungsbeleg",
        "MEASUREMENT_SHEET": "Aufmaßblatt",
        "WORK_ORDER": "Arbeitsschein",
        "RECURRING_ORDER": "Dauerauftrag",
        "PURCHASE_ORDER_EXISTS": "Bestellung vorhanden",
        "PRICE_COMPARISON": "Preisspiegel",
        "SMS": "SMS",
        "INQUIRY_BOOK": "Anfragebuch",
        "RENTAL_SETTLEMENT": "Verleihabrechnung",
        "COMPLAINT": "Reklamation"
      },
      "DESCRIPTION": {
        "DOCUMENT_NOTE": "Zum Beleg ist ein Belegvermerk hinterlegt.",
        "SIGNATURE": "Der Beleg wurde vom Kunden unterschrieben.",
        "DOWN_PAYMENT": "Zum Beleg ist eine Anzahlung erfasst.",
        "MAINTENANCE_DOCUMENT": "Der Beleg ist ein Wartungsbeleg.",
        "MEASUREMENT_SHEET": "Zum Beleg ist ein Aufmaßblatt vorhanden.",
        "WORK_ORDER": "Zum Beleg ist ein Arbeitsschein vorhanden.",
        "RECURRING_ORDER": "Der Beleg stammt aus einem Dauerauftrag.",
        "PURCHASE_ORDER_EXISTS": "Zum Beleg ist eine Bestellung beim Lieferanten vorhanden.",
        "PRICE_COMPARISON": "Zum Beleg ist ein Preisspiegel vorhanden.",
        "SMS": "Zum Beleg wurde eine SMS versendet.",
        "INQUIRY_BOOK": "Der Beleg ist im Anfragebuch eingetragen.",
        "RENTAL_SETTLEMENT": "Zum Beleg ist eine Verleihabrechnung vorhanden.",
        "COMPLAINT": "Zum Beleg ist eine Reklamation erfasst."
      }
    },
    "QUERY": {
      "COPY_DOCUMENT": "Beleg kopieren",
      "COPY_DOCUMENT_HEADER": "Nur Kopfdaten kopieren",
      "FULFILL_DOCUMENT": "Beleg abbuchen",
      "PREVIEW_DOCUMENT": "Druckvorschau anzeigen",
      "FILTER": {
        "TITLE": "Filter",
        "SEARCH": "Suchen...",
        "NO_RESULTS": "Keine Treffer",
        "NO_SELECTED": "Keine Auswahl",
        "TAB_ALL": "Alle",
        "TAB_SELECTED": "Ausgewählt",
        "SELECT_ALL": "Alle auswählen",
        "DESELECT_ALL": "Alle abwählen",
        "RESET": "Zurücksetzen",
        "RESET_ALL": "Alle zurücksetzen",
        "ALL": "Alle",
        "LOAD_ERROR": "Fehler",
        "APPLY": "Übernehmen",
        "CANCEL": "Abbrechen",
        "BACK": "Zurück",
        "STATUS": "Status",
        "CONSTRUCTION_SITES": "Baustellen",
        "USERS": "Anwender",
        "SALES_ORGS": "Verkaufsorganisationen",
        "SALES_REPRESENTATIVES": "Vertreter",
        "PROJECTS": "Projekte",
        "WAREHOUSES": "Lager",
        "DELIVERY_TOURS": "Liefertouren",
        "AGENTS": "Vermittler",
        "DISTRIBUTION_TYPES": "Lieferarten"
      },
      "BUSINESS_CASE": "Geschäftsfall anzeigen",
      "DOCUMENT_NOTES": "Belegvermerke anzeigen",
      "SHOW_ATTACHMENTS": "Anhänge anzeigen",
      "DOWN_PAYMENT_CREDIT_NOTE": "Anzahlungsgutschrift erstellen",
      "DOWN_PAYMENT_CREDIT_NOTE_CREATED": "Anzahlungsgutschrift erstellt: {{document}}"
    },
    "EXPLOSIVES_PROOF": {
      "TITLE": "Nachweis Explosivstoff-Grundstoffe",
      "SUBTITLE": "Nachweis lt. Verordnung (EU) 2019/1148 erfassen",
      "RESTRICTION_REPORTABLE": "Meldepflichtiger Artikel",
      "RESTRICTION_RESTRICTED": "Beschränkter Artikel",
      "RESTRICTION_FORBIDDEN": "Verbotener Artikel",
      "RESTRICTION_HYDROGEN_PEROXIDE": "Wasserstoffperoxid",
      "PROOF_TYPE": "Nachweisart",
      "HUNTING_PERMIT": "Jagdschein",
      "PRIVATE_PERMIT": "Bescheid (Privat)",
      "LICENSE_NUMBER": "Jagdscheinnummer",
      "PERMIT_NUMBER": "Bescheidnummer",
      "PERMIT_AMOUNT": "Bescheidmenge",
      "PRODUCT_DESCRIPTION": "Produktbezeichnung",
      "CANCEL": "Abbrechen",
      "WITHOUT_PROOF": "Ohne Nachweis",
      "APPLY": "Übernehmen"
    },
    "DELETE_ROWS": {
      "TITLE": "Zeile löschen",
      "QUESTION_ONE": "Wollen Sie diese Zeile löschen?",
      "QUESTION_MANY": "Wollen Sie diese {{count}} Zeilen löschen?",
      "DONT_ASK_AGAIN": "Nicht mehr fragen",
      "CANCEL": "Abbrechen",
      "CONFIRM": "Löschen"
    },
    "DOCUMENT_LOAD_ERROR": {
      "TITLE": "Beleg konnte nicht geladen werden",
      "DESCRIPTION": "Beim Laden des Belegs ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
      "RETRY": "Erneut versuchen"
    },
    "LEAVE": {
      "TITLE": "Beleg verlassen",
      "SUBTITLE": "Wie möchten Sie mit dem Beleg fortfahren?",
      "FINALIZE": "Abschließen",
      "FINALIZE_HINT": "Der Beleg wird abgeschlossen und die Belegerfassung verlassen",
      "KEEP_OPEN": "Ohne Abschluss verlassen",
      "KEEP_OPEN_HINT": "Die Änderungen sind gespeichert, der Beleg bleibt zur Bearbeitung offen",
      "POSTPONE": "Zurückstellen",
      "POSTPONE_HINT": "Der Beleg wird zurückgestellt und kann später fortgesetzt werden",
      "DELETE": "Löschen",
      "DELETE_HINT": "Der Beleg wird unwiderruflich gelöscht",
      "CANCEL": "Abbrechen"
    },
    "PRICE_INFO": {
      "MENU": "Preisinfo",
      "TITLE": "Preisinfo",
      "SUBTITLE": "Herkunft der Preisbestandteile dieser Position",
      "EMPTY": "Normaler Verkaufspreis — keine besonderen Preisquellen.",
      "POSITION": "Position",
      "PRICE": "Verkaufspreis",
      "NET": "Netto",
      "CLOSE": "Schließen",
      "DESCRIPTION": {
        "LISTENPREIS": "Listenpreis",
        "NETTOPREIS": "Nettopreis",
        "PREISEBENE": "Preisebene",
        "KONDITIONEN": "Konditionen",
        "DRAUFGABE": "Draufgabe",
        "GUTSCHEIN": "Gutschein"
      },
      "ORIGIN": {
        "PREISGRUPPE_KONDBLATT": "Kondblatt der Preisgruppe",
        "PREISEBENE_PREISEBENZU": "Preisebenen-Zuschlag",
        "PREISEBENE_PREISEBENZUL": "Preisebenen-Zuschlag (Land)",
        "PREISEBENE_ZUABSCHLAG_AUF": "Zu-/Abschlag auf Preisebene",
        "BEWEAUS": "Auszeichnungs-Bewegung",
        "LIEFERART": "Lieferart",
        "VKPREIS": "Standard-VK-Preis",
        "VKFORG_KONDBLATT": "Kondblatt der Verkaufsorganisation",
        "VERKAUFSART_KONDBLATT": "Kondblatt der Verkaufsart",
        "KUNDE_KUNDEDBRABATT": "DB-Rabatt des Kunden",
        "KUNDE_KONDBLATT_DBRABATT": "DB-Rabatt aus Kunden-Kondblatt",
        "KUNDE_KONDBLATT_REF_DBRABATT": "DB-Rabatt aus referenziertem Kondblatt",
        "KUNDE_KONDBLATT": "Kondblatt des Kunden",
        "KUNDE_KONDBLATT2": "Zweites Kondblatt des Kunden",
        "KUNDE_KONDBLATT_REF": "Referenziertes Kondblatt des Kunden",
        "KUNDEKONDBLATT_DBRABATT": "DB-Rabatt Kunde-Kondblatt-Zuordnung",
        "KUNDEKONDBLATT": "Kunde-Kondblatt-Zuordnung",
        "KUNDE_KUNDENKARTE": "Kondblatt der Kundenkarte",
        "KUNDE_DBRABATT": "DB-Rabatt des Kunden",
        "KUNDE_DBRABATT_PRODUKTGRUPPEDB": "DB-Rabatt Produktgruppe",
        "ARTSTAMM_MAXRABATT": "Maximalrabatt des Artikels",
        "KUNDENGRUPPE_KONDBLATT": "Kondblatt der Kundengruppe",
        "KUNDENGRUPPE_KONDBLATT_REF": "Referenziertes Kondblatt der Kundengruppe",
        "KUNDENGRUPPEKONDBLATT": "Kundengruppe-Kondblatt-Zuordnung",
        "KUNDENGRUPPEKONDBLATT_DBRABATT": "DB-Rabatt Kundengruppe-Kondblatt",
        "KONDBLATT_VORSCHLAG": "Kondblatt-Vorschlag",
        "KUNDE_KUNDEAKTION": "Kundenaktion",
        "KUNDENGRUPPE_KUNDENGRUPPEAKT": "Kundengruppen-Aktion",
        "VKFORGAKT": "Aktion der Verkaufsorganisation",
        "VKFORGGRUPPEAKTTION": "Aktion der Vkforg-Gruppe",
        "ERFVARIANTE": "Erfassungsvariante",
        "EINKAUFSPREIS": "Einkaufspreis",
        "AKTIONSEKPREIS": "Aktions-EK-Preis",
        "ABVERKAUF": "Abverkauf"
      }
    },
    "RECALCULATE_PRICE": {
      "TITLE": "Preis neu berechnen",
      "SUBTITLE": "Preisfindung für die Positionen erneut ausführen",
      "PRICE_TYPE": "Preisart",
      "LIST_PRICE": "Listenpreis",
      "CASH_PRICE": "Barpreis",
      "SCOPE": "Umfang",
      "SCOPE_SELECTION": "Auswahl",
      "SCOPE_ALL": "Alle Positionen",
      "SCOPE_HINT": "Positionen im Beleg",
      "AFFECTED": "Betroffene Positionen",
      "OF": "von",
      "POSITIONS": "Positionen",
      "NET": "Netto",
      "KEEP_MANUAL_DISCOUNT": "Manuelle Rabatte beibehalten",
      "CANCEL": "Abbrechen",
      "APPLY": "Neu berechnen"
    },
    "UNIT": {
      "TITLE": "Einheiteneingabe",
      "SUBTITLE": "Mengen je Einheit erfassen",
      "CHANGE_UNIT": "Einheit ändern",
      "ARTICLE": "Artikel",
      "QUANTITIES": "Mengen je Einheit",
      "UNIT": "Einheit",
      "QUANTITY": "Menge",
      "CONSUMER_QUANTITY": "Verrmenge",
      "PRICING_UNIT": "Preisfindung",
      "TOTAL_IN": "Gesamt in",
      "SALES_QUANTITY": "Erfassungsmenge",
      "TOTAL_STOCK": "Lager gesamt",
      "DIMENSIONS": "Abmessungen",
      "DIMENSION": {
        "WIDTH": "Breite",
        "HEIGHT": "Höhe",
        "DEPTH": "Tiefe"
      },
      "CONVERSION_ONLY": "Die Eingabe wird nur umgerechnet — die Aufteilung wird nicht an der Position gespeichert.",
      "CANCEL": "Abbrechen",
      "SAVE": "Übernehmen",
      "CAPTURE_UNIT": "Erf-EH",
      "CAPTURE_PRICE": "Preis Erfassung",
      "STOCK": "Lager",
      "DISTRIBUTION": "Abwicklung",
      "STOCK_LEVEL": "Lagerstand",
      "DISPOSITION_LEVEL": "Dispostand",
      "OUTPUT_UNIT": "Ausgabeeinheit",
      "SPLIT_UNIT": "Aufteilungseinheit",
      "STOCK_IN_UNIT": "Lagerstand",
      "STOCK_PER_BRANCH": "Lagerstand je Filiale",
      "BRANCHES": "Filialen",
      "NEGATIVE": "negativ",
      "OUTPUT_UNIT_LEGEND": "Ausgabeeinheit — verkaufbar",
      "CALC_ONLY_UNIT": "Rechenhilfe — nicht verkaufbar",
      "IN": "in",
      "YOUR_BRANCH": "Ihre Filiale",
      "TOTAL": "Gesamt"
    },
    "MODULE_OPTIONS": {
      "TITLE": "Modul-Optionen",
      "SUBTITLE": "Optionen des Modulartikels wählen",
      "ARTICLE": "Artikel",
      "SUB_MODULE": "Untermodul",
      "FIXED": "fest",
      "CHAIN": "Module in der Kette",
      "CHOSEN": "Gewählt",
      "CHOSEN_SUFFIX": "gewählt",
      "OPEN": "Offen",
      "OPEN_HINT": "offen – Auswahl treffen",
      "ALL_RESOLVED": "Alle Module aufgelöst",
      "LOADING": "Optionen werden ermittelt…",
      "FAILED": "Die Optionen konnten nicht ermittelt werden.",
      "CHANGE": "Modul-Optionen ändern",
      "CANCEL": "Abbrechen",
      "ADD": "Hinzufügen",
      "APPLY": "Übernehmen"
    },
    "SIGNATURE": {
      "TITLE": "Unterschrift",
      "SUBTITLE": "Unterschrift zum Beleg erfassen",
      "DOCUMENT": "Beleg",
      "SIGNER": "Unterzeichner",
      "SIGNATURE": "Unterschrift",
      "COLLECTOR_HINT": "Es wird der am Beleg erfasste Abholer verwendet.",
      "CLEAR": "Löschen",
      "CANCEL": "Abbrechen",
      "SAVE": "Unterschrift speichern",
      "MISSING": "Unterschrift fehlt",
      "MISSING_HINT": "Für diesen Beleg ist eine Unterschrift nötig und noch nicht erfasst.",
      "CAPTURE": "Unterschrift erfassen",
      "SIGNED": "Unterschrieben",
      "DRAFT_HINT": "Die Unterschrift wird nach dem Abschluss des Belegs erfasst.",
      "SAVED": "Unterschrift gespeichert",
      "PLACEHOLDER": "Tippen Sie hier, um zu unterschreiben",
      "PENDING": "Unterschrift ausstehend",
      "CAPTURED": "Unterschrift erfasst",
      "UNDO": "Rückgängig",
      "LOADING": "Unterschrift wird geladen…",
      "FINAL_HINT": "Pro Beleg ist genau eine Unterschrift möglich."
    },
    "PRODUCT_TEXT": {
      "TITLE": "Textposition",
      "SUBTITLE": "Zeilentext bearbeiten",
      "POSITION": "Position",
      "QUANTITY": "Menge",
      "NET": "Netto",
      "PRINT_HINT": "Wird auf Lieferschein und Rechnung gedruckt.",
      "CANCEL": "Abbrechen",
      "SAVE": "Speichern"
    },
    "MULTI_DISCOUNT": {
      "MENU": "Rabatt setzen",
      "TITLE": "Rabatt setzen",
      "SUBTITLE": "Rabatt auf die ausgewählten Positionen anwenden",
      "CONDITION": "Kondition",
      "RATE": "Satz",
      "RATE_INVALID": "Der Satz muss zwischen -100 und 100 liegen (negativ = Aufschlag).",
      "ITEMS": "Ausgewählte Positionen",
      "SELECTED": "Positionen ausgewählt",
      "SELECTED_ONE": "Position ausgewählt",
      "POSITIONS": "Positionen",
      "NET_TOTAL": "Netto gesamt",
      "WITH_DISCOUNT": "mit Rabatt",
      "RATE_HINT": "Satz eingeben, um den Rabatt anzuwenden.",
      "RUNNING": "Rabatt wird angewendet…",
      "SUCCEEDED": "Positionen erfolgreich aktualisiert",
      "FAILED": "Positionen fehlgeschlagen",
      "RETRY": "Fehlgeschlagene erneut anwenden",
      "APPLY": "Anwenden",
      "CANCEL": "Abbrechen",
      "CLOSE": "Schließen"
    },
    "FULFILL": {
      "TITLE": "Von Beleg abbuchen",
      "SUBTITLE": "Position aus einem offenen Beleg in diesen Beleg abbuchen",
      "HINT": "Für diesen Artikel gibt es offene Belege. Statt neu zu erfassen kann von einer bestehenden Position abgebucht werden.",
      "SOURCE": "Quellbeleg",
      "ITEM": "Position",
      "AMOUNT": "Menge",
      "AMOUNT_LABEL": "Menge abbuchen",
      "ALL_OPEN": "Alle auswählen",
      "STOCK": "Lager",
      "STOCK_LEVEL": "Lagerstand",
      "DISPOSITION_LEVEL": "Dispostand",
      "DELIVERY": "Liefertermin",
      "OPEN_SUFFIX": "offen",
      "CUSTOMER": "Kunde",
      "REPRESENTATIVE": "Vertreter",
      "PAYMENT": "Zahlung",
      "ARTICLE": "Artikel",
      "UNIT": "Erf-EH",
      "CAPTURE_PRICE": "Preis Erfassung",
      "DISTRIBUTION": "Abwicklung",
      "COL_DESCRIPTION": "Bezeichnung",
      "COL_OPEN_QTY": "Offene Menge",
      "COL_NET": "Netto",
      "COL_DISCOUNT": "Rabatt",
      "CASH_DISCOUNT": "Skonto",
      "PRICE_MANUAL": "Preis manuell",
      "PICK_HINT": "Position wählen",
      "REMAINS": "verbleibt auf",
      "PRICE_FROM_DOC": "Preis vom Beleg",
      "PRICE_DIFF_SUFFIX": "wird übernommen — abweichend von der aktuellen Erfassung",
      "FILTER_ALL": "Alle",
      "COL_POSITION": "Pos",
      "COL_PRICE": "Preis",
      "COL_OPEN": "Offen",
      "OPEN": "offen:",
      "POSITION_ONE": "offene Position",
      "POSITION_MANY": "offene Positionen",
      "AMOUNT_INVALID": "Die Menge muss größer als 0 sein.",
      "AMOUNT_INVALID_MAX": "Die Menge muss zwischen 0 und der offenen Menge liegen:",
      "APPLY": "Abbuchen",
      "CANCEL": "Neu erfassen",
      "MENU": "Von Beleg abbuchen…",
      "OPEN_POSITIONS": "Offene Positionen"
    },
    "FROM_TEMPLATE": {
      "ACTION": "Neu aus Vorlage",
      "ACTION_TOOLTIP": "Musterbeleg wählen und als neuen Beleg kopieren",
      "SEARCH_ACTION": "Beleg aus Vorlage erstellen",
      "TITLE": "Beleg aus Vorlage erstellen",
      "SUBTITLE": "Musterbeleg wählen – die Kopie wird als neuer Beleg geöffnet",
      "TYPE": "Belegart",
      "SEARCH": "Musterbelege durchsuchen...",
      "COL_NUMBER": "Belegnummer",
      "COL_DATE": "Belegdatum",
      "COL_CUSTOMER": "Kunde",
      "COL_SITE": "Baustelle / Projekt",
      "COL_VALUE": "Wert",
      "EMPTY": "Für {{type}} sind keine Musterbelege gepflegt.",
      "NO_MATCH": "Keine Musterbelege passen zur Suche.",
      "FAILED": "Musterbelege konnten nicht geladen werden.",
      "LOAD_MORE": "Weitere laden",
      "NO_TYPES": "Für die verfügbaren Belegarten gibt es keine Vorlagen-Funktion.",
      "HINT_EMPTY": "Musterbeleg markieren – alle Positionen werden in den neuen Beleg übernommen",
      "HINT_PICKED": "{{type}} {{number}} wird als neuer Beleg kopiert",
      "CANCEL": "Abbrechen",
      "CONFIRM": "Beleg erstellen"
    },
    "FULFILL_FROM_DOCUMENT": {
      "TITLE": "Vom ausgewählten Beleg abbuchen",
      "SUBTITLE": "Positionen und offene Mengen des Belegs übernehmen",
      "CELL_TYPE": "Belegart",
      "CELL_NUMBER": "Belegnummer",
      "CELL_DATE": "Belegdatum",
      "CELL_TOTAL": "Gesamt",
      "POSITIONS": "Positionen",
      "POSITION_ONE": "Position",
      "POSITION_MANY": "Positionen",
      "SELECT_ALL": "Alles markieren",
      "DESELECT_ALL": "Alle abwählen",
      "COL_POSITION": "Pos.",
      "COL_ARTICLE": "Artikel",
      "COL_QUANTITY": "Erfmenge",
      "COL_PRICE": "Preis",
      "COL_TOTAL": "Gesamt",
      "COL_OPEN": "Offen",
      "COL_AMOUNT": "Menge abbuchen",
      "TOTAL_LABEL": "Beleg gesamt",
      "HINT_EMPTY": "Positionen markieren, deren offene Mengen abgebucht werden",
      "HINT_OF": "von",
      "HINT_POSITIONS_NET": "Positionen · Netto",
      "APPLY": "Abbuchen",
      "APPLY_SUFFIX": "Pos.",
      "CANCEL": "Abbrechen"
    },
    "RETURNING_REFERENCE": {
      "TITLE": "Retourbezug wählen",
      "SUBTITLE": "Position des Ursprungsbelegs für die Retoure wählen",
      "NOTICE": "Die Position wird mit negativer Menge auf den Beleg übernommen.",
      "BADGE": "Retoure",
      "CARD_DOCUMENT": "Retoure aus",
      "OPEN": "Beleg öffnen",
      "ORGANISATION": "Verkaufsorganisation",
      "DOCUMENT_DATE": "Belegdatum",
      "DOCUMENT_NUMBER": "Belegnummer",
      "DOCUMENT_TYPE": "Belegart",
      "DOCUMENT_TYPE_ALL": "Alle Belegarten",
      "SEARCH": "Suchen",
      "COL_DOCUMENT": "Beleg",
      "COL_POSITION": "Pos.",
      "COL_DESCRIPTION": "Bezeichnung",
      "COL_RETURNABLE": "Retournierbar",
      "AMOUNT_LABEL": "Retourmenge",
      "AMOUNT_MAX": "maximal",
      "AMOUNT_INVALID": "Die Menge muss größer als 0 sein.",
      "AMOUNT_INVALID_MAX": "Menge darf maximal",
      "AMOUNT_INVALID_MAX_SUFFIX": "sein",
      "EMPTY": "Keine passenden Belegpositionen gefunden.",
      "PICK_HINT": "Position wählen — Retourbezug für die negative Menge",
      "HINT_POSITION": "Position",
      "APPLY": "Übernehmen",
      "CANCEL": "Abbrechen"
    },
    "FULFILLED_REFERENCE": {
      "TOOLTIP_DOCUMENT": "Abgebucht aus",
      "OPEN": "Beleg öffnen"
    },
    "MANUAL_ARTICLE": {
      "TITLE": "Manueller Artikel",
      "SUBTITLE": "Artikeltext und Bezeichnungen bearbeiten",
      "STEP_DESIGNATIONS": "Bezeichnungen",
      "STEP_DESIGNATIONS_SUB": "Kurz- und Langtext",
      "STEP_NUMBERS": "Nummern",
      "STEP_NUMBERS_SUB": "Artikelnr., Beschreibung",
      "SECTION_DESIGNATIONS": "Bezeichnungen",
      "SECTION_DESIGNATIONS_META": "Zeile 1 erscheint auf dem Beleg",
      "SECTION_NUMBERS": "Nummern",
      "CONTEXT_POSITION": "Position",
      "CONTEXT_NO_MASTER": "ohne Artikelstamm",
      "CONTEXT_UNIT": "Erf-EH",
      "CONTEXT_PRICE": "Preis Erfassung",
      "CONTEXT_TAX": "Steuer",
      "DESIGNATION": "Artikelbezeichnung 1",
      "DESCRIPTION_2": "Artikelbezeichnung 2",
      "DESCRIPTION_3": "Artikelbezeichnung 3",
      "DESCRIPTION_4": "Artikelbezeichnung 4",
      "DESCRIPTION_5": "Artikelbezeichnung 5",
      "EXTERNAL_KEY": "Man. Artikelnummer",
      "SUPPLIER_NUMBER": "Lieferant-Artikel-Nr",
      "EAN": "EAN",
      "DESCRIPTION": "Beschreibung",
      "STEP_HINT_1": "Schritt 1 von 2 · Bezeichnungen",
      "STEP_HINT_2": "Schritt 2 von 2 · Nummern & Beschreibung",
      "REQUIRED_HINT": "Artikelbezeichnung 1 angeben",
      "NEXT": "Weiter",
      "BACK": "Zurück",
      "CANCEL": "Abbrechen",
      "SAVE": "Speichern"
    },
    "FINALIZE_STEP": {
      "SELECTCONSTRUCTIONSITE": "Baustelle / Kundennummer auswählen",
      "ENTEREXTERNALPURCHASEORDERNUMBER": "Externe Bestellnummer eingeben",
      "ENTERMANUALADDRESS": "Manuelle Adresse eingeben",
      "SELECTDELIVERYDATERANGE": "Lieferdatum von/bis auswählen",
      "SELECTCOLLECTOR": "Abholer angeben",
      "PAY": "Zahlung durchführen",
      "SIGN": "Signatur erfassen",
      "CREDITLIMIT": "Kreditrahmen beim Kunden hinterlegen"
    },
    "DOCUMENT_OVERVIEW": {
      "TITLE": "Belegübersicht",
      "VIEW_ALL": "Alle ansehen",
      "OPEN": "Offen",
      "TOTAL": "Gesamt"
    },
    "SALES_ORGANISATION": "Verkaufsorganisation",
    "DOCUMENT_NUMBER": "Belegnummer",
    "DOCUMENT_DATE": "Belegdatum",
    "STATUS": "Status",
    "CUSTOMER": "Kunde",
    "CUSTOMER_NAME": "Kundenname",
    "CUSTOMER_NUMBER": "Kundennummer",
    "CONSTRUCTION_SITE": "Baustelle",
    "CUSTOMER_SUB_NUMBER": "Baustellennummer",
    "INVOICE_CUSTOMER_NUMBER": "Rechnungskunde Nr.",
    "INVOICE_CUSTOMER_NAME": "Rechnungskunde Name",
    "VALUE": "Wert",
    "TAX_VALUE": "Steuerwert",
    "COST": "Kosten",
    "SALES_REPRESENTATIVE": "Vertreter",
    "USER": "Anwender",
    "PROJECT": "Objekt",
    "PROJECT_NAME": "Projektname",
    "DISTRIBUTION_TYPE": "Lieferart",
    "BARCODE": "Barcode",
    "INVOICED": "Fakturiert",
    "DELIVERED": "Geliefert",
    "DELIVERY_DATE": "Lieferdatum",
    "CONTRACT_DOCUMENT": "Vertragsbeleg",
    "VALID_UNTIL": "Gültig bis",
    "IDKOPFAUS": "idkopfaus",
    "IDKOPFVK": "idkopfvk",
    "INVOICE_APPROVAL": "Rechnungsfreigabe",
    "DELIVERY_TOUR": "Liefertour",
    "DUE_DATE": "Fälligkeitsdatum",
    "PAID": "Bezahlt",
    "REFERENCE_NUMBER": "Referenznummer",
    "TRUCK": "LKW",
    "RECEIPT_NUMBER": "Bonnummer",
    "WAREHOUSE": "Lager",
    "WAREHOUSE_NAME": "Lagername",
    "WORK_ORDER_NUMBER": "Werkauftragsnummer",
    "WORK_ORDER_DESCRIPTION": "Werkauftragsbeschreibung",
    "WORK_ORDER_STATUS": "Werkauftragsstatus",
    "CURRENCY": "Währung",
    "CONTRIBUTION_MARGIN": "DB%",
    "CONTRIBUTION_MARGIN_2": "DB",
    "CREATION_TIME": "Erfzeit",
    "DOCUMENT_NOTE": "Belegvermerk",
    "ID": "id",
    "MARGIN": "DB",
    "MARGIN_PERCENT": "DB%",
    "DISCOUNT": "Rabatt",
    "SUBJECT": "Bezeichnung",
    "LOST": "Verloren",
    "RECEIPT_TYPE": "Beleg",
    "REGISTER_NUMBER": "Kassa",
    "CASHIER": "Kassierer",
    "ASSESSMENT": "Bemessung",
    "VALUE_INCL": "Wert inkl.",
    "INCOME": "Einnahmen",
    "EXPENSES": "Ausgaben",
    "PAID_AMOUNT": "Gezahlt",
    "DIFFERENCE": "Differenz",
    "CREATOR": "Erfasser",
    "TRANSFER_TIME": "Übernahme",
    "DISCOUNT1": "Skonto1",
    "VEHICLE_ALLOCATION": "Fahrzeugeinteilung",
    "DRIVER": "Fahrer",
    "VEHICLE": "Fahrzeug",
    "DELIVERY_HINT": "Lieferhinweis",
    "DELIVERY_DATE_TO": "Lieferdatum bis",
    "DELIVERY_DATE_FROM": "Lieferdatum von",
    "INVOICE_APPROVAL_JN": "Freigegeben",
    "PROJECT_SOURCE": "Objekt Ursache",
    "COST_CENTER_SOURCE": "Kostenstelle Ursache",
    "INVOICE_SUB_TYPE": "Art",
    "DAYS1": "Tage1",
    "DISCOUNT1_INVOICE": "Skonto1",
    "DAYS_NET": "Nettotage",
    "IN_ABROAD": "InAusland",
    "BALANCE": "Saldo",
    "SCAN": "Scan",
    "ACCOUNTING_INDICATOR": "KZ Fibu",
    "ACCOUNTING_DATE": "Fibudatum",
    "PERIOD_DATE": "Per Datum",
    "IDKOPFAR": "idkopfar",
    "CONFIG": {
      "TITLE": "Verkauf",
      "SUBTITLE": "Konfiguration für das Verkaufsmodul",
      "INDENT_POSITIONS": "Positionen einrücken",
      "INDENT_POSITIONS_HINT": "Unterpositionen in der Positionsspalte eingerückt darstellen",
      "DATE_FROM": "Belege ab",
      "DATE_FROM_HINT": "Festes Startdatum für die Belegabfrage (überschreibt Monate zurück)",
      "VALID_DOCUMENT_TYPES": "Gültige Belegarten",
      "VALID_DOCUMENT_TYPES_HINT": "Belegarten die zur Auswahl stehen. Keine Auswahl = alle erlaubt",
      "ALL_DOCUMENT_TYPES": "Alle Belegarten",
      "DEFAULT_DOCUMENT_TYPE": "Standard-Belegart",
      "DEFAULT_DOCUMENT_TYPE_HINT": "Belegart die bei der Neuerstellung vorausgewählt ist",
      "NO_DEFAULT": "Kein Standard",
      "DASHBOARD_MONTHS_BACK": "Zeitraum (Monate)",
      "DASHBOARD_MONTHS_BACK_HINT": "Wie viele Monate zurück die Belege im Dashboard gelesen werden",
      "DEFAULT_DISTRIBUTION_TYPE": "Standard-Lieferart",
      "DEFAULT_DISTRIBUTION_TYPE_HINT": "Lieferart die bei der Neuerstellung vorausgewählt ist",
      "SAVE": "Speichern",
      "SAVED": "Einstellungen gespeichert",
      "AGING_BUCKETS": "Aging-Buckets",
      "AGING_LABEL": "Bezeichnung",
      "AGING_FROM_DAYS": "Von (Tage)",
      "AGING_TO_DAYS": "Bis (Tage)",
      "AGING_TO_DAYS_OPEN": "Offen",
      "AGING_ADD": "Bucket hinzufügen",
      "AGING_REMOVE": "Bucket entfernen",
      "AGING_DEFAULT": "Standard",
      "AGING_USING_DEFAULTS": "Standard-Buckets aktiv",
      "AGING_CUSTOMIZE": "Anpassen",
      "AGING_RESET": "Auf Standard zurücksetzen"
    },
    "WIZARD": {
      "NEXT": "Weiter",
      "CONFIRM": "Bestätigen",
      "CREATE_DOCUMENT": "Beleg erstellen",
      "SELECT_CUSTOMER": "Kunde auswählen",
      "SELECT_CONSTRUCTION_SITE": "Baustelle auswählen",
      "CONSTRUCTION_SITE": "Baustelle",
      "MANUAL_CONSTRUCTION_SITE": "Manuelle Baustelle",
      "MANUAL_CONSTRUCTION_SITE_PLACEHOLDER": "Manuelle Baustelle eingeben...",
      "SELECT_DELIVERY_TYPE": "Lieferart auswählen",
      "SET_DELIVERY_DATE": "Lieferdatum festlegen",
      "FROM": "Von",
      "TO": "Bis",
      "CALENDAR_WEEK": "Kalenderwoche",
      "PREFERRED_TIME": "Gew. Lieferzeit",
      "DELIVERY_NOTE": "Lieferanmerkung",
      "COLLECTOR": "Abholer",
      "COLLECTOR_PLACEHOLDER": "Name des Abholers...",
      "NOTE_PLACEHOLDER": "Anmerkung eingeben..."
    },
    "CREDIT_LIMIT": {
      "TITLE": "Kreditlimit",
      "WITHIN_LIMIT": "Im Rahmen",
      "EXCEEDED": "Limit überschritten",
      "AVAILABLE": "verfügbar",
      "OVERDRAWN": "überzogen",
      "LOADING": "Laden..."
    },
    "CUSTOMER_HISTORY": {
      "TITLE": "Kundenhistorie",
      "MODE_ARTICLE": "Dieser Artikel",
      "MODE_CUSTOMER": "Alle Artikel",
      "CUSTOMER_SUBLINE": "Alle Artikel im gewählten Zeitraum",
      "NO_ARTICLE_MODE": "Kein Stammartikel gewählt – alle Artikel des Kunden",
      "SEARCH": "Artikel oder Belegnummer suchen...",
      "OPEN_ONLY": "Nur offene",
      "PERIOD_FROM": "von",
      "PERIOD_TO": "bis",
      "PRESET_1Y": "1 Jahr",
      "PRESET_2Y": "2 Jahre",
      "PRESET_5Y": "5 Jahre",
      "PRICE_LAST": "Letzter Preis",
      "PRICE_PREVIOUS": "Davor",
      "PRICE_RANGE": "Spanne",
      "PRICE_CURRENT": "Aktuelle Position",
      "PRICE_SAME": "wie zuletzt",
      "PRICE_DISTINCT": "{{count}} verschiedene Preise",
      "PRICE_CONSTANT": "unverändert im Zeitraum",
      "APPLY_PRICE": "Preis übernehmen",
      "APPLY_PRICE_HINT": "Setzt {{price}} als manuellen Preis auf die aktuelle Position",
      "PRICE_INFO": "Preisinfo",
      "POSITIONS_ONE": "1 Position",
      "POSITIONS_MANY": "{{count}} Positionen",
      "EMPTY_TITLE": "Keine Belege im Zeitraum",
      "EMPTY_ARTICLE": "Der Kunde hat diesen Artikel im Zeitraum nicht bezogen.",
      "EMPTY_CUSTOMER": "Der Kunde hat im Zeitraum keine Belege.",
      "NO_MATCH": "Keine Positionen passen zu Filter und Suche.",
      "RESET_FILTER": "Filter zurücksetzen",
      "TIMEOUT_TITLE": "Abfrage hat zu lange gedauert",
      "TIMEOUT_DESCRIPTION": "Wählen Sie einen früheren Stichtag.",
      "FAILED_TITLE": "Abfrage fehlgeschlagen",
      "FAILED_DESCRIPTION": "Bitte versuchen Sie es erneut.",
      "RETRY": "Erneut versuchen",
      "OPEN_DOCUMENT": "Beleg {{number}} öffnen",
      "RETURN": "Retoure",
      "CLOSE": "Panel schließen"
    },
    "RETURNABLE_PACKAGING": {
      "TITLE": "Emballagen",
      "SEARCH": "Emballage suchen...",
      "OPEN_ONLY": "Nur offene",
      "AS_OF_DATE": "Stichtag",
      "TODAY": "Heute",
      "SUMMARY_OPEN": "Offene Emballagen",
      "SUMMARY_BALANCE": "Saldo gesamt",
      "SUMMARY_OUT": "Ausgegeben",
      "SUMMARY_BACK": "Retour",
      "COUNT_PACKAGING": "{{count}} Emballagen",
      "AT_CUSTOMER": "beim Kunden",
      "CREDIT": "Guthaben",
      "SETTLED": "ausgeglichen",
      "STOCK_SHORT": "Vortrag",
      "OUT_SHORT": "aus",
      "BACK_SHORT": "retour",
      "EMPTY_TITLE": "Keine Emballagen zum Stichtag",
      "EMPTY_DESCRIPTION": "Für diesen Kunden sind zum Stichtag keine Emballagen erfasst.",
      "NO_MATCH": "Keine Emballagen passen zu Filter und Suche.",
      "RESET_FILTER": "Filter zurücksetzen",
      "TIMEOUT_TITLE": "Abfrage hat zu lange gedauert",
      "TIMEOUT_DESCRIPTION": "Wählen Sie einen früheren Stichtag.",
      "FAILED_TITLE": "Abfrage fehlgeschlagen",
      "FAILED_DESCRIPTION": "Bitte versuchen Sie es erneut.",
      "RETRY": "Erneut versuchen",
      "CLOSE": "Panel schließen"
    },
    "CUSTOMER_PRODUCT": {
      "TITLE": "Kunden-Artikel-Statistik",
      "SUBTITLE": "Verkaufte Artikel des Kunden im Zeitraum",
      "SEARCH": "Artikel suchen …",
      "FROM": "Von",
      "TO": "bis",
      "TYPES_LABEL": "Belegarten",
      "CONFIRM": "Übernehmen",
      "CANCEL": "Abbrechen",
      "EMPTY": "Keine Artikel im gewählten Zeitraum",
      "FAILED": "Abfrage fehlgeschlagen — bitte den Zeitraum verkleinern",
      "PRICE_HINT": "Preis wird vom Beleg neu ermittelt",
      "FOOTER_SUMMARY": "{{count}} Positionen · Netto {{net}} · {{hint}}",
      "FOOTER_PICKED": "{{type}} {{number}} · {{priceLevel}} · {{price}} — {{hint}}",
      "COL_DATE": "Datum",
      "COL_DOCUMENT": "Beleg",
      "COL_PRODUCT": "Artikel",
      "COL_QUANTITY": "Menge",
      "COL_PRICE": "Preis",
      "COL_NET": "Netto",
      "COL_MARGIN": "Marge",
      "CTX_SALES_ORG": "Verkaufsorganisation",
      "CTX_PRICE_LEVEL": "Preisstufe",
      "CTX_DISTRIBUTION": "Versandart",
      "CTX_NET_TOTAL": "Netto gesamt",
      "MANUAL_ARTICLE": "Manueller Artikel – kann nicht übernommen werden",
      "TIMEOUT": "Die Abfrage hat das Zeitlimit des Servers (30 s) überschritten – bitte Zeitraum verkleinern oder weniger Belegarten wählen"
    },
    "DOCUMENT_DISCOUNTS": {
      "TITLE": "Kopfrabatte",
      "RATE_INVALID": "Der Satz muss zwischen -100 und 100 liegen (negativ = Aufschlag).",
      "DELETE": {
        "TITLE": "Kopfrabatt löschen",
        "QUESTION": "Diesen Kopfrabatt wirklich löschen?"
      },
      "MESSAGES": {
        "CREATED": "Kopfrabatt gespeichert",
        "UPDATED": "Kopfrabatt aktualisiert",
        "DELETED": "Kopfrabatt gelöscht"
      }
    },
    "BUSINESS_CASE": {
      "TITLE": "Geschäftsfall",
      "NO_DOCUMENT": "Keinen Beleg ausgewählt."
    },
    "SIDE_PANEL": {
      "CLOSE": "Seitenpanel schließen"
    }
  },
  "#DOCUMENT_QUERY": {
    "TITLE": "Belegabfrage"
  },
  "SALES_DOCUMENT": {
    "CREATE": {
      "EXCEPTION": "Beim Erzeugen des Belegs ist ein Fehler aufgetreten."
    },
    "UPDATE": {
      "EXCEPTION": "Beim Update des Belegs ist ein Fehler aufgetreten."
    },
    "READ": {
      "EXCEPTION": "Beim Einlesen des Belegs ist ein Fehler aufgetreten."
    },
    "DELETE": {
      "EXCEPTION": "Beim Löschen des Belegs ist ein Fehler aufgetreten."
    },
    "FINALIZE": {
      "EXCEPTION": "Beim Abschluss des Belegs ist ein Fehler aufgetreten."
    },
    "VALIDATE": {
      "EXCEPTION": "Beim Prüfen des Belegs ist ein Fehler aufgetreten."
    },
    "COUNTRY": {
      "CANNOT_BE_EMPTY": "Land darf nicht leer sein."
    },
    "DESTINATION_TYPE": {
      "NOT_EDITABLE": "Der Zielbeleg kann nur im Entwurf geändert werden."
    },
    "PAYMENT_METHOD": {
      "DIRECT_DEBIT_INVALID_FOR_CUSTOMER": "Zahlungsart mit Bankeinzug ist bei diesem Kunden nicht gültig!"
    },
    "STORAGE_SITE": {
      "INACTIVE": "Lager ist nicht aktiv."
    },
    "STOCK": {
      "MANDATORY_FIELD": "Lager ist Pflichtfeld.",
      "NOT_PERMITTED_WITH_DISTRIBUTION_TYPE": "Bei dieser Lieferart sind keine Streckenlager erlaubt.",
      "NO_PERMISSION": "Keine Berechtigung für das Lager {{key}}"
    },
    "OBJEKT": {
      "COMPLETED_THEREFORE_INVALID": "Das Objekt ist bereits erledigt, und somit nicht gültig!"
    },
    "CUSTOMER_CARD": {
      "BLOCKED_SINCE": "Kundenkarte ist seit dem {{blockedDate:DATE_DEFAULT}} gesperrt."
    },
    "CUSTOMER": {
      "CANNOT_SWITCH_CUSTOMER_DIFFERENT_CURRENCY": "Auf einen Kunden mit anderer Waehrung darf nicht gewechselt werden.",
      "IS_LOCKED": "Kunde ist gesperrt."
    },
    "LAYOUT": {
      "CANNOT_BE_NULL": "Layout darf nicht null sein."
    },
    "REPRESENTATIVE": {
      "INACTIVE": "Vertreter nicht mehr aktiv."
    },
    "DISTRIBUTION_TYPE": {
      "INACTIVE": "Lieferart nicht aktiv.",
      "INVALID": {
        "PURCHASE_RECEIPT": "Lieferart für Einkaufsbeleg nicht gültig.",
        "SALES_RECEIPT": "Lieferart für Verkaufsbeleg nicht gültig."
      },
      "ONLY_INTERNAL_FOR_CUSTOMER": "Es dürfen nur interne Lieferarten für diesen Kunden verwendet werden!",
      "INTERNAL_NOT_ALLOWED_FOR_CUSTOMER": "Es dürfen keine interne Lieferarten für diesen Kunden verwendet werden!",
      "NOT_PERMITTED_MINIMUM_MARGIN": "Lieferart nicht zulässig aufgrund der M-Spanne."
    },
    "ITEM": {
      "NOT_FOUND": {
        "GENERAL": "Bewegung nicht gefunden!",
        "IN_DOCUMENT": "Bewegung in diesem Beleg nicht gefunden!"
      },
      "READ": {
        "EXCEPTION": "Beim Einlesen von Bewegungen in diesem Beleg ist ein Fehler aufgetreten."
      },
      "CREATE": {
        "EXCEPTION": "Beim Erzeugen der Position ist ein Fehler aufgetreten.",
        "MISSING_FIELD": {
          "DESCRIPTION_NO_ITEM": "Zeilentext muss übergeben werden, wenn kein Artikel übergeben wird!"
        }
      },
      "DELETE": {
        "EXCEPTION": "Beim Löschen von Bewegungen in diesem Beleg ist ein Fehler aufgetreten.",
        "RENTAL_BILLING_EXISTS": "Löschen nicht möglich. Es sind Zeilen selektiert, für welche bereits Verleih-Abrechnungen existieren."
      },
      "UPDATE": {
        "EXCEPTION": "Beim Updaten der Position in diesem Beleg ist ein Fehler aufgetreten."
      },
      "PRODUCT": {
        "NOT_FOUND": "Artikel nicht gefunden."
      },
      "POSITION": {
        "ONLY_ALLOWED_FOR_MANUAL_NUMBERING": "Positionsnummer darf nur bei manueller Positionsnummerierung gesetzt werden."
      },
      "CONSUMER_QUANTITY": {
        "NOT_ALLOWED_ON_ITEM_WITH_CHILDREN": "Verrechnungsmenge kann auf einer Bewegung mit Unterbewegungen nicht gesetzt werden."
      },
      "PRICE": {
        "TAX_ID": {
          "NOT_EDITABLE": "Steuersatz für diese Position nicht editierbar.",
          "NOT_ALLOWED_BY_PARENT": "Der Ustsatz {{requested}} ist an dieser Position nicht erlaubt – Modul/Pauschale gibt {{parent}} vor."
        }
      },
      "PRICE_OF_GOODS": {
        "NET_INCL_NOT_SUPPORTED": "Zahlungsbetrag (inkl. Steuer) kann für den Materialpreis nicht gesetzt werden.",
        "PRICE_INCL_NOT_SUPPORTED": "Preis inkl. Steuer kann für den Materialpreis nicht gesetzt werden.",
        "TAX_ID_NOT_SUPPORTED": "Steuersatz kann für den Materialpreis nicht gesetzt werden."
      },
      "SELLING_TYPE": {
        "CONTAINER_NOT_SUPPORTED": "Verkaufsart mit Behälterhandling wird über diese Schnittstelle nicht unterstützt."
      },
      "COST_CENTER": {
        "NOT_IN_PROJECT": "Kostenstelle nicht im Objekt hinterlegt.",
        "NOT_IN_PROJECT_GROUP": "Kostenstelle nicht in Objektgruppe hinterlegt."
      },
      "CUSTOMIZATION": {
        "NOT_ALLOWED_FOR_PRODUCT": "Manuelle Artikelanpassung ist für diesen Artikel nicht möglich."
      },
      "STOCK": {
        "MUST_NOT_BE_EMPTY": "Lager darf nicht leer sein.",
        "INVALID_FOR_DISTRIBUTION_TYPE": "Ungültiges Lager für aktuelle Lieferart."
      },
      "CASH_DISCOUNT": {
        "EXCEEDS_LIMIT": "Der eingegebene Skontosatz ist zu hoch und kann nicht übernommen werden."
      },
      "DISCOUNT": {
        "CONDITION_ID_MISMATCH": "Die Konditions-ID in Pfad und Anfrage stimmen nicht überein.",
        "NOT_FOUND": "Der Rabatt für diese Kondition wurde auf der Position nicht gefunden."
      },
      "CONFIRMATIONS": {
        "EXCEPTION": "Beim Ermitteln der Bestätigungen ist ein Fehler aufgetreten."
      },
      "DISTRIBUTION_TYPE": {
        "NOT_EDITABLE": "Lieferart ist auf dieser Position nicht editierbar."
      },
      "PRICE_OF_SERVICE": {
        "NET_INCL_NOT_SUPPORTED": "Zahlungsbetrag (inkl. Steuer) kann für den Arbeitspreis nicht gesetzt werden.",
        "PRICE_INCL_NOT_SUPPORTED": "Preis inkl. Steuer kann für den Arbeitspreis nicht gesetzt werden.",
        "TAX_ID_NOT_SUPPORTED": "Steuersatz kann für den Arbeitspreis nicht gesetzt werden."
      },
      "UNDO_FLATRATE": {
        "EXCEPTION": "Beim Auflösen der Pauschale ist ein Fehler aufgetreten.",
        "NOT_FLATRATE_ITEM": "Nur Pauschalartikel können aufgelöst werden."
      },
      "ADD_TO_NEW_FLATRATE": {
        "EXCEPTION": "Beim Erstellen der Pauschale ist ein Fehler aufgetreten.",
        "CONTAINS_FLATRATE": "Die Auswahl darf keine Pauschalartikel enthalten."
      },
      "ADD_TO_NEW_SECTION": {
        "EXCEPTION": "Beim Erstellen des Abschnitts ist ein Fehler aufgetreten."
      },
      "MOVE": {
        "EXCEPTION": "Beim Verschieben der Positionen ist ein Fehler aufgetreten."
      },
      "ATTRIBUTE": {
        "UPDATE": {
          "EXCEPTION": "Beim Ändern des Attributs ist ein Fehler aufgetreten."
        },
        "NOT_MODIFIABLE": "Änderung dieses Attributs ist nicht möglich.",
        "PICK_UP": {
          "NOT_ALLOWED_FOR_DISTRIBUTION_TYPE": "Abholschein für Lieferart nicht möglich!"
        },
        "PICK_UP_DIGITAL_STORAGE": {
          "NOT_POSSIBLE": "Abholschein nicht möglich!"
        },
        "CAN_ONLY_BE_SET_VIA_ACTION": "Dieses Attribut kann nur über eine Aktion gesetzt werden.",
        "UNKNOWN": "Unbekanntes Attribut.",
        "PROMOTION": {
          "RESTORE_NOT_REMOVED": "Wiederherstellen der Aktion nicht möglich, da diese nicht entfernt wurde.",
          "REMOVE_ALREADY_REMOVED": "Entfernen der Aktion nicht möglich, da diese bereits entfernt wurde."
        }
      },
      "UNIT_COMPOSITION": {
        "EXCEPTION": "Bei der Einheiteneingabe ist ein Fehler aufgetreten.",
        "NOT_SUPPORTED_FOR_ITEM": "Einheiteneingabe ist für diese Position nicht möglich.",
        "NOT_SUPPORTED_FOR_WEIGHT_PRODUCT": "Einheiteneingabe ist für Gewichtsartikel nicht möglich.",
        "NOT_ALLOWED_ON_ITEM_WITH_CHILDREN": "Einheiteneingabe ist auf einer Position mit Unterpositionen nicht möglich.",
        "UNIT_NOT_ALLOWED": "Die Einheit ist für diese Position nicht zulässig.",
        "CONSUMER_UNIT_NOT_SELECTABLE": "Diese Einheit kann nicht als Verrechnungseinheit gewählt werden.",
        "ZERO_QUANTITY_NOT_ALLOWED": "Die eingegebene Menge darf nicht 0 sein.",
        "DIMENSIONS_INCOMPLETE": "Es müssen alle Abmessungen eingegeben werden."
      }
    },
    "MANUAL_TERMS_OF_PAYMENT": {
      "EXCEPTION": "Manuellezahlkond konnte nicht gelöscht werden."
    },
    "TERMS_OF_PAYMENT": {
      "EXCEPTION": "Manuellezahlkond konnte nicht gelöscht werden."
    },
    "ADDRESS": {
      "EXCEPTION": "Manadresse konnte nicht gelöscht werden."
    },
    "DELIVERY_ADDRESS": {
      "EXCEPTION": "Lieferadresse (Manadresse) konnte nicht gelöscht werden."
    },
    "PRINT": {
      "EXCEPTION": "Fehler beim Drucken."
    },
    "DISCOUNT": {
      "CONDITION_NOT_USEABLE_FOR_DOCUMENT_DISCOUNT": "Die gewählte Kondition ist nicht für Kopfrabatte zugelassen.",
      "CONDITION_ID_MISMATCH": "Die Konditions-ID in Pfad und Anfrage stimmen nicht überein.",
      "NOT_FOUND": "Am Beleg existiert kein Kopfrabatt mit dieser Kondition.",
      "ADD": {
        "EXCEPTION": "Beim Anlegen des Kopfrabatts ist ein Fehler aufgetreten."
      },
      "UPDATE": {
        "EXCEPTION": "Beim Ändern des Kopfrabatts ist ein Fehler aufgetreten."
      },
      "DELETE": {
        "EXCEPTION": "Beim Löschen des Kopfrabatts ist ein Fehler aufgetreten."
      }
    }
  }
}
